module.exports = __webpack_public_path__ + "2bd41c2886fd91a923c9de047363809c.svg";